
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 24C6.01 24 .96 21.4.96 18.34V5.94C.96 3.09 4.42 0 12 0s11.04 3.08 11.04 5.95v6.22a.5.5 0 01-1 0V8.55C20.53 10.41 17.25 11.9 12 11.9S3.47 10.41 1.96 8.55v3.69c0 2.17 2.37 4.75 9.05 4.86a.5.5 0 11-.02 1c-4.88-.08-7.69-1.47-9.03-3.15v3.39C1.96 20.54 6.26 23 12 23c.3 0 .59 0 .88-.02a.5.5 0 01.04 1q-.45.02-.92.02zM1.96 5.95c0 1.98 2.68 4.94 10.04 4.94s10.04-2.96 10.04-4.95S19.36 1 12 1 1.96 3.96 1.96 5.95z"}}),_c('path',{attrs:{"d":"M18.5 24a5.5 5.5 0 01-1.38-.18.5.5 0 01-.37-.5 1 1 0 00-.95-1.06.98.98 0 00-.6.16.5.5 0 01-.63-.07 5.46 5.46 0 01-.84-1.1 5.47 5.47 0 01-.53-1.27.5.5 0 01.25-.58 1 1 0 000-1.79.5.5 0 01-.25-.58 5.51 5.51 0 011.37-2.38.5.5 0 01.63-.07 1 1 0 001.38-.3.98.98 0 00.16-.6.5.5 0 01.38-.5 5.52 5.52 0 012.75 0 .5.5 0 01.38.5 1 1 0 00.94 1.06 1.02 1.02 0 00.6-.16.5.5 0 01.63.07 5.55 5.55 0 011.38 2.38.5.5 0 01-.25.58 1 1 0 000 1.78.5.5 0 01.25.58 5.52 5.52 0 01-1.37 2.38.5.5 0 01-.63.07 1 1 0 00-1.55.9.5.5 0 01-.37.5 5.5 5.5 0 01-1.38.18zm-.78-1.07a4.51 4.51 0 001.55 0 2 2 0 012.68-1.54 4.49 4.49 0 00.77-1.35 2 2 0 010-3.08 4.6 4.6 0 00-.77-1.35 2.04 2.04 0 01-.8.12 2 2 0 01-1.88-1.66 4.52 4.52 0 00-1.55 0 2 2 0 01-2.67 1.54 4.51 4.51 0 00-.78 1.35 1.98 1.98 0 01.51.63 2 2 0 01-.51 2.45 4.66 4.66 0 00.33.7 4.55 4.55 0 00.45.64 2.05 2.05 0 01.8-.12 2 2 0 011.87 1.67zm.78-2.43a2 2 0 112-2 2 2 0 01-2 2zm0-3a1 1 0 101 1 1 1 0 00-1-1z"}})])
          )
        }
      }
    